module.exports = __webpack_public_path__ + "img/fb-icon.3ea2a29f.svg";